var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 11,
    className: "arrow-right_svg__ecs_hl_cz"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00af7d",
    d: "M.43 5.597a.5.5 0 01.5-.5h13.998l-3.68-3.674a.497.497 0 010-.707.5.5 0 01.707 0l4.54 4.531a.5.5 0 01-.098.784.506.506 0 01-.077.1l-4.365 4.363a.5.5 0 11-.707-.707l3.69-3.69H.93a.5.5 0 01-.5-.5z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDE3IDExIiBjbGFzcz0iZWNzX2hsX2N6Ij48cGF0aCBmaWxsPSIjMDBhZjdkIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0uNDMgNS41OTdhLjUuNSAwIDAgMSAuNS0uNWgxMy45OThsLTMuNjgtMy42NzRhLjQ5Ny40OTcgMCAwIDEgMC0uNzA3LjUuNSAwIDAgMSAuNzA3IDBsNC41NCA0LjUzMWEuNS41IDAgMCAxLS4wOTguNzg0LjUwNi41MDYgMCAwIDEtLjA3Ny4xbC00LjM2NSA0LjM2M2EuNS41IDAgMSAxLS43MDctLjcwN2wzLjY5LTMuNjlILjkzYS41LjUgMCAwIDEtLjUtLjV6Ij48L3BhdGg+PC9zdmc+";
export { SvgArrowRight as ReactComponent };